import React, { useState } from "react";
import { useTranslation } from "react-i18next";

import { MDBAlert, MDBBtn, MDBModalFooter, MDBSpinner } from "mdb-react-ui-kit";
import { deleteFreshdeskProfile} from "../../../apiclients/streamsapi_bridge.js";

const DeleteProfile = (props) => {
  const [internalError, setInternalError] = useState(false);
  const { t, i18n } = useTranslation();
  const [isloading, setIsloading] = useState(false);

  async function removeThisProfile(e) {
    try {
      setInternalError(false);
      setIsloading(true);
      let deleteProfileReponse = await deleteFreshdeskProfile(JSON.parse(sessionStorage.getItem("admin_session")).siteid, props.profileId);
      setTimeout(() => { setIsloading(false) }, 1000);
      let delInfo = await deleteProfileReponse.json();
      if (deleteProfileReponse.status == 200) {
        if (delInfo.status == 'success') {
          localStorage.setItem("s_message", delInfo.message);
        } else {
          localStorage.setItem("f_message", delInfo.message);
        }
      } else if (delInfo.status == 400) {
        localStorage.setItem("f_message", delInfo?.message?.errors?.[0]?.message ?? delInfo?.message);
      } else if (delInfo.status == 500) {
        setInternalError(true);
      }
      window.location.href = "/apilanding";
      props.onClose();
    } catch (e) {
      console.log(`Unable to process Request :Internal server Error:!`);
      setInternalError(true);
    }
  }
  return (
    <>
      {internalError && (<MDBAlert
        open
        className="alert-center"
        color="danger"
        autohide
        position="bottom-right"
        delay={5000}
      >Internal Server Error</MDBAlert>)}
      <div>
        <span className="phrecording">{t("RemoveProfiletxt")}</span>
      </div>
      <MDBModalFooter>
        <MDBBtn color="secondary" onClick={props.onClose}>
          {t("cancel")}
        </MDBBtn>
        <MDBBtn onClick={(e) => removeThisProfile(e)}>{t("remove")}</MDBBtn>
      </MDBModalFooter>
      {isloading && (
        <>
          <div className="loadingclass">
            <MDBBtn disabled>
              <MDBSpinner size="sm" role="status" tag="span" className="me-2" />
              Loading...
            </MDBBtn>
          </div>
        </>
      )}
    </>
  );
};

export default DeleteProfile;
